// extracted by mini-css-extract-plugin
module.exports = {"smsConfirm":"style-module--smsConfirm--2VQbD","newPass":"style-module--newPass--1AAR3"};